<template>
    <div class="cards-list-list__list-item">
        <h2 class="cards-list-list__list-item-title h4">{{ card.title }}</h2>
        <div class="cards-list-list__list-item-body">
            <DSCFText :content="card.text" />
            <div v-if="card?.links?.length > 0" class="cards-list-list__list-item-links">
                <NuxtLink
                    v-for="link in card.links"
                    :key="link.id"
                    class="ds-btn ds-btn--large ds-btn--primary"
                    :to="link.url.value"
                >
                    <span>{{ link.title }}</span>
                </NuxtLink>
            </div>
        </div>
    </div>
</template>
<script setup>
defineProps({
    card: {
        type: Object,
        required: true,
    },
});
</script>

